var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"dashboard-core-footer","absolute":""}},[_c('v-container',{attrs:{"id":"footer-container","fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }